import { useTranslations, useLocale } from '@/i18n/context';
import { LanguageSwitcher } from '@/components/language-switcher';

export function Footer() {
  const t = useTranslations('footer');
  const locale = useLocale();

  return (
    <footer
      id="footer"
      className="relative bg-[color:var(--mp-ink)] text-[color:var(--mp-cream)]"
    >
      <div className="mx-auto max-w-[1440px] px-6 pt-20 pb-10 md:px-12 md:pt-28 lg:px-20">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
          <div className="md:col-span-6">
            <div className="font-display text-5xl leading-[0.95] md:text-7xl">
              Moepie
              {locale === 'zh' && (
                <span className="font-serif-cn ml-3 text-lg align-middle tracking-brand text-[color:var(--mp-cream)]/60">
                  萌派
                </span>
              )}
            </div>
            <p
              className="font-serif-cn mt-8 max-w-lg text-[15px] leading-[2] text-[color:var(--mp-cream)]/75"
              // eslint-disable-next-line react/no-danger -- trusted translation
              dangerouslySetInnerHTML={{ __html: t('tagline') }}
            />
            <div className="mt-10 flex flex-wrap items-center gap-6 text-[11px] uppercase tracking-[0.28em] text-[color:var(--mp-cream)]/60">
              <a
                href="https://www.douyin.com/user/moepie"
                target="_blank"
                rel="noreferrer noopener"
                className="mp-underline"
              >
                {t('douyin')}
              </a>
              <a
                href="https://www.xiaohongshu.com/user/profile/moepie"
                target="_blank"
                rel="noreferrer noopener"
                className="mp-underline"
              >
                {t('xhs')}
              </a>
              <span className="hidden md:inline">Tmall</span>
              <span className="hidden md:inline">JD</span>
              <span className="hidden md:inline">
                <LanguageSwitcher variant="dark" />
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[color:var(--mp-signal)]">
              {t('contact')}
            </div>
            <ul className="mt-6 space-y-3 text-[14px] text-[color:var(--mp-cream)]/80">
              <li>
                <span className="block text-[10px] uppercase tracking-[0.24em] text-[color:var(--mp-cream)]/50">
                  {t('email')}
                </span>
                moepieonline@moepie.net
              </li>
              <li>
                <span className="block text-[10px] uppercase tracking-[0.24em] text-[color:var(--mp-cream)]/50">
                  {t('address')}
                </span>
                <span
                  // eslint-disable-next-line react/no-danger -- trusted translation
                  dangerouslySetInnerHTML={{ __html: t('addressValue') }}
                />
              </li>
              <li>
                <span className="block text-[10px] uppercase tracking-[0.24em] text-[color:var(--mp-cream)]/50 mb-3">
                  {t('wechat')}
                </span>
                <div className="w-24 h-24 bg-white rounded-md p-1.5">
                  <img
                    src="/wechat-qrcode.png"
                    alt="微信二维码"
                    className="w-full h-full object-contain"
                  />
                </div>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[color:var(--mp-signal)]">
              {t('shop')}
            </div>
            <ul className="mt-6 space-y-3 text-[14px] text-[color:var(--mp-cream)]/80">
              <li>
                <a
                  href="https://moepie.tmall.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="mp-underline w-fit"
                >
                  {t('tmall')}
                </a>
              </li>
              <li>
                <a
                  href="https://moepie.jd.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="mp-underline w-fit"
                >
                  {t('jd')}
                </a>
              </li>
              <li className="mp-underline w-fit">{t('douyinShop')}</li>
              <li className="mp-underline w-fit">{t('xhsShop')}</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 flex flex-col items-start justify-between gap-4 border-t border-[color:var(--mp-cream)]/15 pt-8 text-[11px] uppercase tracking-[0.22em] text-[color:var(--mp-cream)]/50 md:flex-row md:items-center">
          <div>{t('copyright')}</div>
          <div className="flex flex-wrap items-center gap-6">
            <a
              href="https://beian.mps.gov.cn/#/query/webSearch?code=44011302005761"
              rel="noreferrer"
              target="_blank"
              className="flex items-center gap-1.5 hover:underline"
            >
              <img
                src="/beian-icon.png"
                alt="公安备案图标"
                className="w-4 h-4"
              />
              <span>{t('policeRecord')}</span>
            </a>
            <span>{t('icp')}</span>
            <span>{t('madeIn')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
